import { createFileRoute } from "@tanstack/react-router"
import { PublicInfoPage } from "@/components/PublicInfoPage"

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <PublicInfoPage eyebrow="Wild Guess" title="Privacy Policy">
      <p>
        Last updated July 18, 2026. Wild Guess Trivia is operated by Club West
        Creative LLC.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We collect the information needed to run the app and games, including
        account details such as phone number, an email address if you add one
        for account access, Wild Points updates, or a Wild Pass reservation,
        first name, last initial, game activity, scores, rewards, support
        messages, and basic device or diagnostic information.
      </p>

      <h2>How We Use Information</h2>
      <p>
        We use this information to authenticate players and hosts, operate live
        games, save progress and rewards, send account, Wild Points, or Wild
        Pass updates you requested, prevent abuse, improve reliability, and
        respond to support requests.
      </p>

      <h2>Service Providers</h2>
      <p>
        We use trusted service providers for authentication, hosting, analytics,
        crash reporting, app delivery, and related operations. These providers
        process information on our behalf so the app can function.
      </p>

      <h2>Data Sharing</h2>
      <p>
        We do not sell personal information. We may share information when
        required to operate the service, comply with law, protect users, or
        complete a business transaction involving the app.
      </p>

      <h2>Choices</h2>
      <p>
        You can contact us to request access, correction, or deletion of your
        account information. Some records may need to be retained for security,
        compliance, or operational reasons.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about privacy can be sent to{" "}
        <a href="mailto:henry@clubwestcreative.com">
          henry@clubwestcreative.com
        </a>
        .
      </p>
    </PublicInfoPage>
  )
}
